import { uniq } from 'lodash';
import { useMemo } from 'react';
import selfPermissions, { companyAttributes } from 'src/assets/static/SelfPermissions';
import useAuth from './useAuth';
import useCompany from './useCompany';

interface IPermission {
  permissions: string[];
  or?: boolean;
  clientId?: string;
  clientIds?: string[];
  companyAttribute?: boolean;
}

const usePermission = ({ permissions, or, clientId, clientIds, companyAttribute = false }: IPermission) => {
  const { user } = useAuth();
  const { attributes } = useCompany();
  
  const hasPermission = useMemo(
    () =>
      permissions[or ? 'some' : 'every']((permission) => {
        const isSelfPermission = selfPermissions.includes(permission);
        const hasPermission = user?.Role?.includes(permission);
        const isCompanyAttribute = companyAttributes.includes(permission);

        if(isCompanyAttribute && companyAttribute){
          return attributes.includes(permission);
        }

        if (isSelfPermission) {
          if (clientIds?.length) {
            const uniqueClientIds = uniq(clientIds.map((value) => value.toString()));
            if (uniqueClientIds.length === 1) {
              return uniqueClientIds[0]?.toString() === user?.ClientId?.toString() && hasPermission;
            } else {
              return false;
            }
          } else if (clientId) {
            const sameUser = (clientId as string)?.toString() === user?.ClientId?.toString();
            return sameUser && hasPermission;
          }
          return hasPermission;
        }

        return hasPermission;
      }),
    [attributes, clientId, clientIds, companyAttribute, or, permissions, user?.ClientId, user?.Role]
  );

  return hasPermission;
};

export default usePermission;
